/**
 *
 * HeaderScriptLoader
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Helmet } from 'react-helmet';

function HeaderScriptLoader(props) {
  const {
    includeVWOScript,
    includeHotjarScript,
    includeThankYouPagePixel,
    includeCriteoSignupScript,
    includeCriteoConversionScript,
    ...rest
  } = props;

  return (
    <Helmet {...rest}>
      {/* <!-- Start VWO Async SmartCode --> */}
      {includeVWOScript && (
        <script type="text/javascript">
          {`window._vwo_code = window._vwo_code || (function(){
        var account_id=525003,
        settings_tolerance=2000,
        library_tolerance=2500,
        use_existing_jquery=false,
        is_spa=1,
        hide_element='body',

        /* DO NOT EDIT BELOW THIS LINE */
        f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
        window.settings_timer=setTimeout('_vwo_code.finish()',settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());`}
        </script>
      )}
      {/* <!-- End VWO Async SmartCode --> */}
      {/* <!-- Hotjar Tracking Code --> */}
      {includeHotjarScript && (
        <script>
          {`(function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:2274349,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
        </script>
      )}
      {includeThankYouPagePixel && (
        // Event snippet for Cashfree_ThankYou Page on : Please do not remove.
        // Place this snippet on pages with events you’re tracking.
        // Creation date: 12/18/2021
        <script>
          {`gtag('event', 'conversion', {
            'allow_custom_scripts': true,
            'send_to': 'DC-11500821/invmedia/cashf000+standard'
          });`}
        </script>
      )}
      {includeThankYouPagePixel && (
        <noscript>
          {`<img
            src="https://ad.doubleclick.net/ddm/activity/src=11500821;type=invmedia;cat=cashf000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=1?"
            width="1"
            height="1"
            alt=""
          />`}
        </noscript>
      )}
      {includeCriteoSignupScript && (
        // <!-- Criteo Signup Tag -->
        <script type="text/javascript">
          {`window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 92074 },
                { event: "setEmail", email: "##Email Address##", hash_method: "##Hash Method##" },
                { event: "setSiteType", type: deviceType},
                { event: "setZipcode", zipcode: "##Zip Code##" },
                { event: "viewBasket", item: [
                    {id: "1", price: "1", quantity: "1" }
                    //add a line for each additional line in the basket
                ]}
            );`}
        </script>
        // <!-- END Criteo Signup Tag -->
      )}
      {includeCriteoConversionScript && (
        // <!-- Criteo Conversion Tag -->
        <script type="text/javascript">
          {`window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 92074 },
                { event: "setEmail", email: "##Email Address##", hash_method: "##Hash Method##" },
                { event: "setSiteType", type: deviceType},
                { event: "setZipcode", zipcode: "##Zip Code##" },
                { event: "trackTransaction", id: Math.floor(Math.random() * 100000), item: [
                        {id: "1", price: "1", quantity: "1" }
                        //add a line for each additional line in the order
                ]}
            );`}
        </script>
        // <!-- END Criteo Conversion Tag -->
      )}
    </Helmet>
  );
}

HeaderScriptLoader.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  includeVWOScript: PropTypes.bool,
  includeHotjarScript: PropTypes.bool,
  includeThankYouPagePixel: PropTypes.bool,
  includeCriteoSignupScript: PropTypes.bool,
  includeCriteoConversionScript: PropTypes.bool,
};

export default HeaderScriptLoader;
